import { Controller, type Control } from 'react-hook-form';
import { Checkbox } from '@shared/components';
import type { MotorplanPaymentValues } from '../schemas/motorplanPayment.schema';

interface Props {
    control: Control<MotorplanPaymentValues>;
}

const EMAIL_ID = 'motorplan-payment-email';
const EMAIL_ERROR_ID = 'motorplan-payment-email-error';
const SMS_ID = 'motorplan-payment-sms';
const SMS_ERROR_ID = 'motorplan-payment-sms-error';
const CHANNELS_LEGEND_ID = 'motorplan-payment-channels';

const ErrorText = ({ id, message }: { id: string; message: string }) => (
    <p id={id} className="text-sm text-mp-error">
        {message}
    </p>
);

export function MotorplanChannelFields({ control }: Props) {
    return (
        <fieldset className="space-y-2" aria-labelledby={CHANNELS_LEGEND_ID}>
            <legend id={CHANNELS_LEGEND_ID} className="text-sm font-medium text-mp-foreground">
                Send the payment link by
            </legend>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
                <Controller
                    name="sendViaEmail"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <div className="space-y-1">
                            <Checkbox
                                ref={field.ref}
                                id={EMAIL_ID}
                                label="Email"
                                checked={field.value}
                                onChange={field.onChange}
                                ariaDescribedBy={error ? EMAIL_ERROR_ID : undefined}
                            />
                            {error?.message && <ErrorText id={EMAIL_ERROR_ID} message={error.message} />}
                        </div>
                    )}
                />
                <Controller
                    name="sendViaSms"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <div className="space-y-1">
                            <Checkbox
                                ref={field.ref}
                                id={SMS_ID}
                                label="Text"
                                checked={field.value}
                                onChange={field.onChange}
                                ariaDescribedBy={error ? SMS_ERROR_ID : undefined}
                            />
                            {error?.message && <ErrorText id={SMS_ERROR_ID} message={error.message} />}
                        </div>
                    )}
                />
            </div>
        </fieldset>
    );
}
